<template>
  <div>
    <div class="data-panel eye-move-panel">
      <ue :pd="ues.pd" :content="ues.content" v-if="$service.PROJ_CODE==='l28' || $service.PROJ_CODE==='demo'"></ue>
      <div class="data-panel-header">
        <h2>眼动关注点清单</h2>
        <div class="extra">
          <label class="ux-filter-title">日期</label>
          <a-radio-group v-model="filter.attentionDate" style="margin-right: 4px;" button-style="solid">
            <a-radio-button v-for="pdate in options.dates" :key="pdate.value" :value="pdate.id">{{pdate.label}}</a-radio-button>
          </a-radio-group>        
          <a-range-picker :value="attention_range_value" @change="(v) => changeFilterDate(v, 'attentionDate')" :disabled-date="disabledRangeDate" :allowClear="false" v-if="$service.PROJ_CODE!='l28'"/>
          <RangePicker :value="attention_range_value" :defaultValue="attention_range_value" @change="(v) => changeFilterDate(v, 'attentionDate')"  v-else style="width:300px; display: inline-block;"/>
          
        </div>
      </div>
      <div class="data-panel-content">
        <div class="eye-legend">
          <div class="legend-item">
            <div class="i-box i-problem"></div>
            <div class="title">存在问题</div>
          </div>
          <div class="legend-item">
            <div class="i-box"></div>
            <div class="title">不存在问题</div>
          </div>
          <div class="legend-item">
            <div class="i-box i-unpack"></div>
            <div class="title">未进包</div>
          </div>
        </div>
        <div :style="{paddingTop: '24px'}">
          <a-table :loading="loading.attention" rowKey="id" :pagination="pagination" :columns="attnColumns" :data-source="filterAttentionList" bordered size="middle">
          </a-table>
        </div>
      </div>
    </div>
    <div class="data-panel eye-move-panel">
      <div class="data-panel-header">
        <h2>节点评分</h2>
        <div class="extra">
          <label class="ux-filter-title">日期</label>
          <a-radio-group v-model="filter.rateDate" style="margin-right: 4px;" button-style="solid">
            <a-radio-button v-for="pdate in options.dates" :key="pdate.value" :value="pdate.id">{{pdate.label}}</a-radio-button>
          </a-radio-group>        
          <a-range-picker :value="rate_range_value" @change="(v) => changeFilterDate(v, 'rateDate')" :disabled-date="disabledRangeDate" :allowClear="false" v-if="$service.PROJ_CODE!='l28'"/>
          <RangePicker :value="rate_range_value" :defaultValue="rate_range_value" @change="(v) => changeFilterDate(v, 'rateDate')"  v-else style="width:300px; display: inline-block;"/>
        </div>        
      </div>
      <div class="data-panel-content">
        <a-table class="rate-table-wrap" :loading="loading.rate" rowKey="id" :pagination="pagination" :columns="rateColumns" :data-source="filterRateList" bordered size="middle">
          <div slot="remark" slot-scope="text" class="remark-text">
            <a-tooltip overlayClassName="remark-tooltip-wrap">
              <div slot="title" class="remark-tooltip-text">{{text}}</div>
              <span class="remark-content">{{text}}</span>
            </a-tooltip>
          </div>        
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import _, { isNil } from 'lodash';
import RangePicker from "@/components/common/search/range_picker.vue";
import ue from "./ue.vue";

export default {
  name: 'EyeMove',
  components: {
    RangePicker,
    ue
  },
  data() {
    return {
      ues: {
        pd: [{name: '张皓宇', email: 'wf.zhanghaoyu@corp.netease.com'}],
        content: [{name: '张东锐', email: 'zhangdongrui@corp.netease.com'}]
      },
      filter: {
        attentionDate: ``,
        rateDate: ``,
      },
      loading: {
        attention: false,
        rate: false,
      },
      attentionList: [],
      rateList: [],
      options: {
        dates: [
          { id: `${moment().subtract(7, 'days').format('YYYY-MM-DD')}|${moment().format('YYYY-MM-DD')}`, label: '近7天' },
          { id: `${moment().subtract(1, 'months').format('YYYY-MM-DD')}|${moment().format('YYYY-MM-DD')}`, label: '近一个月' },
          { id: `${moment().subtract(3, 'months').format('YYYY-MM-DD')}|${moment().format('YYYY-MM-DD')}`, label: '近三个月' },
          { id: '', label: '全部' },
        ]
      },
      colors: ['#D34446', '#D85B5C', '#DC7172', '#E49D9E', '#EDC9CA', '#F5F5F5', '#CBEBD4', '#A1E1B2', '#77D791', '#62D280', '#4DCC6F'], // [-5, 5]
      pagination: {
        pageSize: 30,
        showSizeChanger: true,
        showQuickJumper: true,
        size: "middle",
      },      
    }
  },
  mounted() {
    this.getEyeAttention();
    this.getNodeRate();
  },
  computed: {
    attention_range_value() {
      const value =  this.filter.attentionDate
      if(value && value!='') {
        const [start_dt, end_dt] = value.split('|');
        return [moment(start_dt), moment(end_dt)];
      }
      else {
        return [];
      }
    },
    rate_range_value() {
      const value =  this.filter.rateDate
      if(value && value!='') {
        const [start_dt, end_dt] = value.split('|');
        return [moment(start_dt), moment(end_dt)];
      }
      else {
        return [];
      }
    },
    attnKeyNumMap() {
      // 构建卡点
      const res = {};
      this.attentionList.forEach(attn => {
        if (!_.isNil(attn.checkpoints)) {
          Object.keys(attn.checkpoints).forEach(point => {
            const tmpCount = attn.checkpoints[point] && attn.checkpoints[point].trim().startsWith("存在问题") ? 1 : 0;
            if (!res[point]) {
              res[point] = tmpCount;
            } else {
              res[point] += tmpCount;
            }
          })
        }
      });
      return res;
    },
    attnKeys() {
      const res = [];
      // 取前20个
      Object.entries(this.attnKeyNumMap).forEach(([k, v]) => {
        res.push({
          label: k,
          value: v
        })
      })
      return _.take(res.sort((prev, next) => (next.value - prev.value)), 20);
    },
    filterAttentionList() {
      let [start_dt, end_dt] = this.filter.attentionDate && this.filter.attentionDate!=''?this.filter.attentionDate.split('|'):[null, null]
      if(start_dt==null) {
        start_dt = '2000-01-01'
      }
      if(end_dt==null) {
        end_dt = '2999-12-31'
      }
      return this.attentionList
        .filter((attention) => moment(attention.test_time).isBetween(start_dt, end_dt, 'day', '[]'))
        .sort((prev, next) => (moment(prev.test_time).isBefore(moment(next.test_time)) ? 1 : -1))
        .map((attn) => ({
          ...attn,
          format_test_time: moment(attn.test_time).format('YYYY/MM/DD'),
          player_name: `玩家${attn.user_id}`,
          // ...(_.isNil(attn.checkpoints) ? {} : attn.checkpoints)
        }));
    },
    attnColumns() {
      return [
        { title: '测试日期', dataIndex: 'format_test_time', width: 110, defaultSortOrder: 'descend', sorter: (prev, next) => (prev.test_time - next.test_time) },
        { title: '玩家', dataIndex: 'player_name', width: 100, sorter: (prev, next) => (prev.user_id - next.user_id) },
        { title: '版本', dataIndex: 'version', width: 80 },
        ...this.attnKeys.map(ak => ({ 
          title: ak.label, 
          dataIndex: ak.label, 
          width: '5%',
          customCell: (record, rowIndex) => {
            let bgColor = '#fff';
            const tmpResult = record.checkpoints?.[ak.label];
            if (!isNil(tmpResult)) {
              if (tmpResult.trim().startsWith("存在问题")) {
                bgColor = '#D34446';
              }
              if (tmpResult.trim().indexOf('未测试') !== -1) {
                bgColor = '#d9d9d9';
              }
              
            }
            return {
              style: {
                background: bgColor
              }
            };
          }
        }))
      ]
    },
    filterRateList() {
      let [start_dt, end_dt] = this.filter.rateDate && this.filter.rateDate!=''?this.filter.rateDate.split('|'):[null, null]
      if(start_dt==null) {
        start_dt = '2000-01-01'
      }
      if(end_dt==null) {
        end_dt = '2999-12-31'
      }
      return this.rateList
        .filter((rate) => moment(rate.test_time).isBetween(start_dt, end_dt, 'day', '[]'))
        .sort((prev, next) => (moment(prev.test_time).isBefore(moment(next.test_time)) ? 1 : -1))
        .map((rt) => {
          return {
            ...rt,
            format_test_time: moment(rt.test_time).format('YYYY/MM/DD'),
            player_name: `玩家${rt.user_id}`,
            age: isNil(rt.born) ? '-' : Math.abs(moment(rt.born).diff(moment(), 'years')),
            r_1: rt.screaminess[0],
            r_3: rt.screaminess[1],
            r_5: rt.screaminess[2],
            r_15: rt.screaminess[3],
            r_25: rt.screaminess[4],
            r_sd: rt.screaminess[5],
            r_3v3: rt.screaminess[6],
            r_jjc: rt.screaminess[7],
          }
        });
    },
    rateColumns() {
      const screamChild = [
        { label: '1', value: 'r_1' },
        { label: '3', value: 'r_3' },
        { label: '5', value: 'r_5' },
        { label: '15', value: 'r_15' },
        { label: '25', value: 'r_25' },
      ];
      const modeChild = [
        { label: '乱斗', value: 'r_sd' },
        { label: '333', value: 'r_3v3' },
        { label: '竞技场', value: 'r_jjc' },
      ]
      return [
        { title: '测试日期', dataIndex: 'format_test_time', width: 100, defaultSortOrder: 'descend', sorter: (prev, next) => (prev.test_time - next.test_time) },
        { title: '玩家', dataIndex: 'player_name', width: 100, sorter: (prev, next) => (prev.user_id - next.user_id) },
        { title: '性别', dataIndex: 'gender', width: 48 },
        { title: '年龄', dataIndex: 'age', width: 48 },
        {
          title: '体验评分(局)',
          children: screamChild.map((sc) => ({
            title: sc.label,
            dataIndex: sc.value,
            width: 32,
            customCell: (record, rowIndex) => {
              const bgColor = this.getRateColor(record[`${sc.value}`])
              return {
                style: {
                  background: bgColor
                }
              };
            }
          }))
        },
        {
          title: '评分(玩法)',
          children: modeChild.map((mc) => ({
            title: mc.label,
            dataIndex: mc.value,
            width: 60,
            customCell: (record, rowIndex) => {
              const bgColor = this.getRateColor(record[`${mc.value}`])
              return {
                style: {
                  background: bgColor
                }
              };
            }
          }))
        },
        { title: '游戏经历', dataIndex: 'game_expr', scopedSlots: { customRender: 'remark' }, width: '30%' },
        { title: '评分原因', dataIndex: 'reason', scopedSlots: { customRender: 'remark' }, width: '70%' },
        { title: '版本', dataIndex: 'version', width: 80 },
        { title: '平台', dataIndex: 'phone', width: 90 },
        { title: '主测人', dataIndex: 'facilitator', width: 100 },
      ]
    }
  },
  methods: {
    getEyeAttention() {
      this.loading.attention = true;
      this.$service.query_fixed_module(`experience_eye_eyemovement`).then(res => {
        this.loading.attention = false;
        if (res.data) {
          this.attentionList = res.data;
        }
      }).catch(() => {
        this.loading.attention = false;
      })
    },
    getNodeRate() {
      this.loading.rate = true;
      this.$service.query_fixed_module(`experience_eye_eyeinfo`).then(res => {
        this.loading.rate = false;
        if (res.data) {
          this.rateList = res.data;
        }
      }).catch(() => {
        this.loading.rate = false;
      })
    },
    changeFilterDate(value, filterKey) {
      const [start_date, end_date] = value;
      this.filter[filterKey] = `${start_date.format('YYYY-MM-DD')}|${end_date.format('YYYY-MM-DD')}`;
    },
    disabledRangeDate(current) {
      return current && current > moment().endOf('day');
    },
    getRateColor(val) {
      return _.isNil(val) ? '#fff' : (this.colors[val + 5] || '#fff')
    }
  }
}
</script>

<style lang="less">
.eye-move-panel {
  padding-bottom: 20px;
  &.data-panel {
    margin-top: 0;
  }
  .ux-filter-title {
    margin-right: 20px;
    font-weight: bold;
  }
  .data-panel-content {
    padding-top: 12px;
  }
  //
  .eye-legend {
    display: flex;
    align-items: center;
    justify-content: center;
    .legend-item {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 32px;
      &:first-child {
        padding-left: 0;
      }
      .i-box {
        width: 40px;
        height: 32px;
        border: 1px solid #ddd;
        &.i-problem {
          border: none;
          background-color: #D34446;        
        }
        &.i-unpack {
          border: none;
          background-color: #d9d9d9;
        }
      }
      .title {
        padding-left: 6px;
      }
    }
  }
  .remark-text {
    white-space: pre-line;
    text-align: left;
  }
  .remark-content {
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  // .rate-table-wrap {
  //   .ant-table-thead,
  //   .ant-table-tbody {
  //     font-size: 12px;
  //   }
  // }
}
.remark-tooltip-wrap {
  max-width: 520px;
}
.remark-tooltip-text {
  white-space: pre-line;
}
</style>